import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import { cn } from "@/lib/cn";
import { isUndefined } from "@/utils/typeGuards";
import type {
  FilterKeys,
  RequiredOnly,
} from "@dresscode-frontend/utility-types";
import type { ColumnDef } from "@tanstack/react-table";
import type { HelperOptions } from "../types";

type Align = "left" | "right";

interface SimpleNumberColumnOptions
  extends RequiredOnly<HelperOptions, "i18nKey"> {
  align?: Align;
}

/** 数値を表示するカラム */
export function simpleNumberColumn<TData>(
  id: FilterKeys<TData, number | undefined>,
  options: SimpleNumberColumnOptions,
): ColumnDef<TData> {
  const {
    i18nKey,
    minWidth = "160px",
    align = "right",
    sortable = false,
  } = options;

  return {
    accessorKey: id,
    enableSorting: sortable,
    meta: { i18nKey, thStyle: { minWidth } },
    header: (props) => <DataTableColumnHeader {...props} align={align} />,
    cell({ row, getValue }) {
      const value = getValue();
      const isSubRow = row.depth > 0;
      return (
        <div
          className={cn(
            isSubRow ? "text-xs text-neutral-muted-on-fill" : "text-sm",
            "font-semibold",
            align === "right" && "text-right",
          )}
        >
          {isUndefined(value) ? "-" : value}
        </div>
      );
    },
  } satisfies ColumnDef<TData, number | undefined> as ColumnDef<TData>;
}
